import { setToModel } from '@/utils/objects'
import { api } from '@/services/api'

export default {
  name: 'FormWrapperAutoSave',
  props: {
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      // Public
      apiPatch: '', // Path for Patch a form item
      // Private
      privateCurrentPromise: Promise.resolve(),
      privateQueue: []
    }
  },
  computed: {
    /**
     * @desc Defines the ability to auto save data
     * @return {Boolean}
     */
    isAvailableToSave () {
      return this.hasCreateNew && !this.disabled
    }
  },
  methods: {
    // Public Methods
    getFormData () {
      if (!this.$refs.Form) {
        console.error('Not found a form')
        return {}
      } else {
        return this.$refs.Form.getData()
      }
    },
    ConfigModel () {
      return {
        id: null,
        api: this.apiPatch || '', // String : api url => "Stocks/Patch/${data.id}"
        requestMethod: null, // String : <link function> => the link for request method, by default "defaultRequestMethod"
        required: false, // The field will not auto save if the value is empty
        rules: [], // Custom rules => [{ validator: function (rule, value, callback) { } }],
        formData: {}, // dataForm
        payloadData: {}, // payload to save
        cb: (er, result) => ({})
      }
    },
    /**
     * @desc Main method for update data base field
     * @param {String} fieldName - name of field
     * @param {Any} fieldValue - value witch will be save,
     * @param {Object<ConfigModel>} config
     * if this prop is missing will be get a value from form data
     */
    handlerUpdateModelItem (fieldName, fieldValue, config = {}) {
      if (!this.isAvailableToSave) return
      this.$nextTick(() => {
        config = setToModel(this.ConfigModel(), config)
        // TODO: Fix server bug
        let value = (fieldValue === '' || fieldValue === undefined || Object.is(fieldValue, NaN))
          ? null
          : fieldValue
        this._validateModelItem(fieldName, value, config)
          .then(() => {
            this._updateModelItem(fieldName, value, config)
          })
          .catch((err) => {
            // eslint-disable-next-line
            console.warn(err)
          })
      })
    },
    defaultRequestMethod (fieldName, value, config) {
      let data = this.getFormData()
      let id = config.id || data.id || this.currentID
      const saveData = {
        ...config.payloadData,
        id,
        [fieldName]: value
      }
      return api
        .patch(this.checkEs6AndRun(config.api, { ...data, id }), saveData)
    },
    handlerSuccessUpdateModelQueue () {
    },
    _handlerSuccessUpdateModel (payload) {
      const { config, fieldName, value } = payload
      const { cb } = config

      cb(null, { fieldName, value })

      this.handlerSuccessUpdateModel(payload)
    },
    handlerSuccessUpdateModel (payload) {
    },
    _handlerErrorUpdateModelItem (err, payload) {
      const { config, fieldName, value } = payload
      const { cb } = config

      cb(err, { fieldName, value })

      this.handlerErrorUpdateModelItem(err, payload)
    },
    // eslint-disable-next-line handle-callback-err
    handlerErrorUpdateModelItem (err, payload) {
    },
    /**
     * @desc Validate item
     * @param {String} fieldName
     * @param {Any} value
     * @param {Object<ConfigModel>} config
     * @returns {Promise<never>|Promise<unknown[]>}
     * @private
     */
    _validateModelItem (fieldName, value, config) {
      return Promise.all([
        this._validateModelItemRequired(fieldName, value, config),
        this._validateModelItemRules(fieldName, value, config)
      ])
    },
    /**
     * @desc Checkout required field
     * @param {String} fieldName
     * @param {Any} value
     * @param {Object<ConfigModel>} config
     * @returns {Promise<never>|Promise<unknown[]>}
     * @private
     */
    _validateModelItemRequired (fieldName, value, config) {
      return new Promise((resolve, reject) => {
        if (config.required && (value == null || value === '')) {
          reject(new Error(`The field ${fieldName} is required`))
        } else {
          resolve()
        }
      })
    },
    /**
     * @desc Validate custom rules
     * @param {String} fieldName
     * @param {Any} value
     * @param {Object<ConfigModel>} config
     * @returns {Promise<never>|Promise<unknown[]>}
     * @private
     */
    _validateModelItemRules (fieldName, value, config) {
      let { rules } = config
      return Promise.all(rules.map(rule => this._validateRule(rule, value)))
    },
    /**
     * @desc Validate ONE Rule
     * @param {Object} rule
     * @param {Any} value
     * @returns {Promise<unknown>}
     * @private
     */
    _validateRule (rule, value) {
      return new Promise((resolve, reject) => {
        const callback = function (result) {
          if (result instanceof Error) {
            reject(result)
          } else {
            resolve()
          }
        }
        if (rule && rule.validator && typeof rule.validator === 'function') {
          rule.validator(rule, value, callback)
        } else {
          callback(new Error('Rule must be an object with method validator'))
        }
      })
    },
    /**
     * @desc Request update item
     * @param {String} fieldName
     * @param {Any} value
     * @param {Object<ConfigModel>} config
     * @returns {Promise}
     * @private
     */
    _updateModelItem (fieldName, value, config) {
      this.privateQueue.push(() => {
        let promise
        if (config.requestMethod && typeof (this[config.requestMethod]) === 'function') {
          promise = this[config.requestMethod](fieldName, value, config)
        } else {
          promise = this.defaultRequestMethod(fieldName, value, config)
        }
        promise = promise
          .then(() => {
            this._handlerSuccessUpdateModel({ fieldName, value, config })
          })
          .catch(err => {
            return this._handlerErrorUpdateModelItem(err, { fieldName, value, config })
          })
        return promise
      })
      this.privateCurrentPromise = this.privateCurrentPromise
        .then(() => {
          return this.privateQueue.shift()()
        })
        .then(() => {
          if (this.privateQueue.length === 0) {
            this.handlerSuccessUpdateModelQueue()
          }
          return Promise.resolve()
        })
    }
  }
}
